/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { ReactNode } from 'react'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Theme } from '@nexigendigital/nxui'
import { WEIGHT } from 'helpers/constants'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    children: ReactNode
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Nav ({ children }: Props) {
    return (
        <nav aria-label={'Products'}>
            <StyledNav>
                {children}
            </StyledNav>
        </nav>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledNav = styled.ol`
    background-color: ${props => props.theme['background--100']};
    border-radius: 16px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 10%), 0 1px 2px rgb(0 0 0 / 6%);
    
    button {
        width: 100%;
        padding: 18px 0 18px 24px;
        font-size: .875rem;
        font-weight: ${WEIGHT.MEDIUM};
        color: ${props => props.theme['text--300']};
        background-color: ${props => props.theme['white--100']};
        border-bottom: 1px solid #e5e7eb;
        ${Theme.Functions.animation('transition-all')};

        &:hover {
            color: #373179;
            background-color: ${props => (props.theme['background--100'])};
        }
        
        &:first-child {
            border-top-left-radius: 16px;
            border-top-right-radius: 16px;
        }
        
        &:last-child {
            border-bottom: none;
            border-bottom-left-radius: 16px;
            border-bottom-right-radius: 16px;
        }
        
        &:disabled {
            cursor: default;
            color: ${props => props.theme['icon--100']};
        }

        &.selected {
            color: #373179;
            background-color: #eef2ff;
        }
    }
`
